import { IPlatformLogDTO } from "./IPlatformLogDTO";

export type PlatformStatusTypes = "a" | "i" | "x";

export enum PlatformStatusEnum {
  ACTIVE = "a",
  INACTIVE = "i",
  DELETED = "x",
}

export type PlatformLastHealthStatusTypes = "o" | "f" | "d";

export enum PlatformLastHealthStatusEnum {
  ONLINE = "o",
  OFFLINE = "f",
  DEGRADED = "d",
}

export interface IPlatformStatusDTO {
  status: PlatformStatusTypes;
  text: string;
  title: string;
  color: string;
}

export interface IPlatformDTO {
  id: number;
  name: string;
  description?: string;
  url: string;
  lastHealthCheck: PlatformLastHealthStatusTypes;
  status: PlatformStatusTypes;
  createdAt: Date;
  updatedAt: Date;
}

export interface IPlatformListDTO {
  id: number;
  name: string;
  description?: string;
  url: string;
  lastHealthCheck: PlatformLastHealthStatusTypes;
  status: PlatformStatusTypes;
  log?: IPlatformLogDTO;
  createdAt: Date;
  updatedAt: Date;
}

export interface IPlatformStatusSelectDTO {
  status: PlatformStatusTypes;
  text: string;
}
